// ============================================================
// CalendarV2 — 型定義
// ============================================================

export interface VehicleType {
  id: string;
  name: string;
  bg_color: string;
  text_color: string;
  priority?: number;
}

export interface Vehicle {
  id: string;
  vehicle_code: string;
  vehicle_number: string;
  car_type: string;
  car_type_id: string;
  bg_color: string | null;
  text_color: string | null;
  vehicle_type?: VehicleType;
  status: string;
  out_of_use?: boolean;
  priority?: number;
  is_active?: boolean;
  active_from?: string | null;
  active_to?: string | null;
  active?: string;
  [key: string]: any;
}

export interface Reservation {
  id: string;
  vehicle_id: string;
  start_date: string;
  end_date: string;
  customer_name: string;
  status: string;
  bg_color: string | null;
  text_color: string | null;
  contact_code?: string;
  sum_price?: number;
  total_price?: number;
  car_type_id?: string;
  /** 予約メモ（mapReservation が detail から root に展開する） */
  memo?: string;
  comment?: string;
  short_memo?: string;
  /** 予約詳細。カレンダーのキャッシュ予約では未ロード（undefined/null）のことがある */
  detail?: Record<string, any> | null;
  page_id?: string | number;
  [key: string]: any;
}

/** 編集パネルで扱う予約（新規作成フラグ付き） */
export type EditingReservation = Reservation & { __isNew?: boolean };

export interface StatusItem {
  id: number;
  label: string;
  code: string;
  bg_color?: string;
  text_color?: string;
}

/** 座標・レイアウト定数 */
export const GRID_CONFIG = {
  columnWidth: 108,
  slotHeight: 15,
  leftGutterWidth: 72,
  headerHeight: 52,
  overlayMarginX: 3,
  overlayMinHeight: 8,
} as const;

/** 時間スロット定義 */
export interface TimeSlotBucket {
  type: 'bucket';
  id: string;
  label: string;
  hours: number[];
}

export interface TimeSlotHour {
  type: 'hour';
  hour: number;
  label: string;
}

export type TimeSlot = TimeSlotBucket | TimeSlotHour;
